export const FACIAL_MESSAGES = {
	PROCESSING: 'Please wait a moment while we process your data.',
    CENTER_FACE: "Please keep your face straight and in the middle of the screen",
    BLINK_TWICE: "Please blink twice for liveness detection",
    BLINK : "Please blink one more time"
};
